import { z } from 'zod';
import { USER_ROLES } from '../enums.js';
import { latitude, localeSchema, longitude } from './common.js';
/**
 * Контракты внутренних эндпоинтов `/api/internal/*`.
 * Доступ только по заголовку `x-bot-secret`; наружу nginx их не выставляет.
 */
export const telegramIdQuery = z.object({
    telegram_id: z.coerce.number().int().positive(),
});
export const internalUserInfo = z.object({
    known: z.boolean(),
    user_id: z.number().int().positive().nullable(),
    role: z.enum(USER_ROLES).nullable(),
    has_phone: z.boolean(),
    locale: localeSchema,
});
export const saveContactBody = z.object({
    telegram_id: z.number().int().positive(),
    // Телефон подтверждён самим Telegram, формат нормализуем на сервере
    phone: z.string().min(5).max(32),
});
export const saveLocationBody = z.object({
    telegram_id: z.number().int().positive(),
    lat: latitude,
    lon: longitude,
});
export const saveLocaleBody = z.object({
    telegram_id: z.number().int().positive(),
    locale: localeSchema,
});
export const okResponse = z.object({ ok: z.boolean() });
//# sourceMappingURL=internal.js.map